import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'nd-theme';
const EVENT_NAME = 'nd-theme-changed';

export function readNdTheme() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'light' || saved === 'dark') return saved;
  } catch (e) {
    /* localStorage может быть недоступен */
  }
  return 'dark';
}

export function applyNdTheme(theme) {
  if (typeof document === 'undefined' || !document.documentElement) return;
  document.documentElement.classList.toggle('nd-light', theme === 'light');
}

export function setNdTheme(theme) {
  const next = theme === 'light' ? 'light' : 'dark';
  try {
    localStorage.setItem(STORAGE_KEY, next);
  } catch (e) {
    /* localStorage может быть недоступен */
  }
  applyNdTheme(next);
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: next }));
}

/** Общая светлая/тёмная тема для сайдбара и отчёта локальных ПК. */
export function useNdTheme() {
  const [theme, setTheme] = useState(readNdTheme);

  useEffect(() => {
    applyNdTheme(theme);
  }, [theme]);

  useEffect(() => {
    const handler = (e) => setTheme(e.detail === 'light' ? 'light' : 'dark');
    window.addEventListener(EVENT_NAME, handler);
    return () => window.removeEventListener(EVENT_NAME, handler);
  }, []);

  const toggle = useCallback(() => {
    setNdTheme(readNdTheme() === 'light' ? 'dark' : 'light');
  }, []);

  return { theme, isLight: theme === 'light', toggle };
}
